export enum FormModalDisplay {
  LIST,
  SUBMISSION,
  REPORTING,
}
